import { strCode } from "../../consts";

const consentTypes = [
  { id: "INFORMATIONAL", value: strCode.CONSENT_TYPE_INFORMATIONAL },
  { id: "MANDATORY", value: strCode.CONSENT_TYPE_MANDATORY },
  { id: "NOT_MANDATORY", value: strCode.CONSENT_TYPE_NOT_MANDATORY }
];

export default consentTypes;
